import axios from "axios"
// import { useHistory } from 'react-router-dom'


// ** Handle User Login
export const handleLogin = () => {

  console.log('okai')

  return dispatch => {
    return axios.get('/api/info/user').then(response => {
      if (response.data.work) {
        dispatch({
          type: 'LOGIN',
          data: response.data.user.fullName,
          img: `${response.data.user.imageUrl}`,
          kyc: response.data.user.status,
          isAmbassador: response.data.user.isAmbassador,
          ambassadorId: response.data.user.ambassadorId,
          totalClients: response.data.referals.totalClients,
          totalAmount: response.data.referals.totalAmount,
          totalGains: response.data.referals.totalGains,
          firstLevel: response.data.referals.firstLevel
        })
      }
    })
  }
}

// ** Get User Info
export const getUserInfo = () => {
  return dispatch => {
    return axios.get('/api/info/user').then(response => {
      if (response.data.work) {
        dispatch({
          type: 'GET_USER_INFO',
          data: response.data.user.fullName,
          img: `${response.data.user.imageUrl}`,
          kyc: response.data.user.status,
          isAmbassador: response.data.user.isAmbassador,
          ambassadorId: response.data.user.ambassadorId,
          totalClients: response.data.referals.totalClients,
          totalAmount: response.data.referals.totalAmount,
          totalGains: response.data.referals.totalGains,
          firstLevel: response.data.referals.firstLevel
        })
      }
    })
  }
}

//Change user image
export const changeImage = img => {

  return dispatch => {
    dispatch({
      type: 'CHANGE_USER_IMG',
      img
    })
  }
}

//Change user image
export const changeUserName = data => {

  return dispatch => {
    dispatch({
      type: 'CHANGE_USER_NAME',
      data
    })
  }
}

//Pass KYC
export const passKyc = () => {
  return dispatch => {
    dispatch({
      type: 'PASS_KYC'
    })
  }
}
// ** Handle User Logout
export const handleLogout = () => {
  return dispatch => {
    return axios.post('/api/auth/logout').then(response => {

      if (response.data.work) {
        dispatch({ type: 'LOGOUT' })
      }
    })
  }
}
